import React from "react";
import { Search, X } from 'lucide-react';

export default function SearchBar({ value, onChange, onClose, paddingTop = "pt-14 md:pt-4", placeholder = "Rechercher des métiers"}) {
  return (
    <div className={`flex flex-col items-center overflow-y-auto w-full overflow-x-hidden gap-2 ${paddingTop}`}>
      <div className="flex flex-1 w-full max-w-3xl items-center bg-gray-800 rounded-2xl shadow-lg">
          <button
            disabled={true}
            className="py-4 pl-4 transition"
            title="Envoyer"
          >
              <Search size={20} className="text-teal-500"/>
          </button>
          <textarea
            rows={1}
            value={value}
            placeholder={placeholder}
            className="flex-1 bg-transparent resize-none p-4 outline-none placeholder-custom-500"
            onChange={onChange}
          />
          {value !== '' &&
            <button
              className="p-4 transition"
              title="Envoyer"
              onClick={onClose}
            >
                <X size={20} />
            </button>
          }
      </div>
    </div>
  );
}
